import { render, staticRenderFns } from "./LocMenu.vue?vue&type=template&id=83e40142&"
import script from "./LocMenu.vue?vue&type=script&lang=js&"
export * from "./LocMenu.vue?vue&type=script&lang=js&"
import style0 from "./LocMenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports